import { inject, provide, type InjectionKey } from 'vue';

export interface DynamicModalOwner {
    id: string;
    isActive: () => boolean;
}

const DYNAMIC_MODAL_OWNER_KEY: InjectionKey<DynamicModalOwner> = Symbol('dynamicModalOwner');

export const provideDynamicModalOwner = (owner: DynamicModalOwner): void => {
    provide(DYNAMIC_MODAL_OWNER_KEY, owner);
};

export const injectDynamicModalOwner = (): DynamicModalOwner | undefined =>
    inject(DYNAMIC_MODAL_OWNER_KEY, undefined);
